<template>
  <ul
    class="
      flex
      social-nav
      text-center
      justify-between
      sm:justify-center
      w-full
    "
  >
    <li class="nav-item flex justify-center w-16  text-center ">
      <a 
        href="https://www.instagram.com/abriendoeljuegosf/"
        target="_blank"
        @mouseover="onHover(1)"
        @mouseout="notHover(1)"
      >
        <div class="flex flex-row justify-center items-center">
          <base-icon
            icon-name="instagram"
            :text-color="iconColor[0]"
            view-box="0 0 47 45"
            class="inline-block"
            width="100%"
            height="100%"
          >
            <icon-instagram />
          </base-icon>
        </div>
      </a>
    </li>
    <li class="nav-item flex justify-center  w-16 text-center">
      <a 
        href="https://m.facebook.com/pg/abriendoeljuegosf"
        target="_blank"
        @mouseover="onHover(2)"
        @mouseout="notHover(2)"
      >
        <div class="flex flex-row text-blue justify-center items-center">
          <base-icon
            icon-name="facebook"
            :text-color="iconColor[1]"
            view-box="0 0 47 45"
            class="inline-block"
            width="100%"
            height="100%"
          >
            <icon-facebook />
          </base-icon>
        </div>
      </a>
    </li>
    <li class="nav-item youtube flex justify-center  w-16  text-center">
      <a 
        href="https://www.youtube.com/channel/UC-7JZ1Ygxs4JwKVKBn_eEgg"
        target="_blank"
        @mouseover="onHover(3)"
        @mouseout="notHover(3)"
      >
        <div
          class="           
            flex flex-row
            text-center
            justify-center
            content-center"
        >
          <base-icon
            icon-name="youtube"
            :text-color="iconColor[2]"
            view-box="0 -3 30 25"
            class=" inline-block"
            width="100%"
            height="100%"
          >
            <icon-youtube />
          </base-icon>
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    color1: {
      type: String,
      requiered: false,
      default: "rgba(255, 199, 0, 1)"
    }, 
    color2: {
      type: String,
      requiered: false,
      default: "rgba(89, 79, 169, 1)"
    },
  },
  data() {
    return {
      iconColor: [this.color1,this.color1,this.color1]
    }
  },
  methods: {
    onHover(icon) {      
      this.iconColor[icon-1] = this.color2
    },
    notHover(icon) {
      this.iconColor[icon-1] = this.color1
    }
  }
}
</script>

<style scoped>

  .social-nav {
    /* margin: 18rem 0  8rem; */
    margin: 1rem 0  6rem;
    max-width: 32rem;
    justify-content: space-around;
    
  }

  .social-nav .nav-item{
    margin-top: 0;
    margin-bottom: 0;
    padding: 0 ;
    width: 4rem;
  }

  .social-nav .nav-item.youtube {
    width: 5.5rem;
  }

  footer .social-nav {
    justify-content: center;
  }
  footer   .social-nav .nav-item{
    width: 4rem;    
    align-items: center;
    margin-right: 1rem;
    margin-left: 1rem;
    padding: 0 ;
  }

  footer .social-nav  .nav-item.youtube {
    width: 5.6rem;
    /* margin: 1rem 0  1rem; */
    padding: 0 ;
  }

  footer .social-nav {
    margin: 1rem 0  1rem;
    max-width: fit-content;  
} 
  @media screen and (max-width: 280px) {

  .social-nav .nav-item{
    width: 16vw;
  }

  .social-nav .nav-item.youtube {
    width: 21.5vw;
  }

  footer .nav-item{
    width: 3.5vw;    
    align-items: center;
  }

  footer .nav-item.youtube {
    width: 6vw;
  }

  .social-nav {
    margin: 1rem 2rem 4rem;
    padding: 0 1rem;
  }

  footer .contenedor-letras-logo {
    max-width: 100%;
  }
}

  @media screen and (min-width: 640px) {
    .social-nav {
      margin: 0.5rem 0  1rem;
    }

    .social-nav .nav-item{
      width: 6.8rem;
      padding: 0 1.5rem 0 1rem ;
    }

    .social-nav .nav-item.youtube {
      width: 7.2rem;
      padding: 0 1rem 0 0.5rem ;
    }
  }

  @media screen and (min-width: 768px) {
    .footer-derecha .social-nav .nav-item{
      width: 3.6vw;
      padding: 0 0.5vw 0 0.5vw;
      margin: 0;
    }

    .footer-derecha .social-nav .nav-item.youtube {
      width: 4.2vw;
      padding: 0 0.5vw 0 0.5vw;
      margin: 0;
    }

    footer  .social-nav {
      max-width: 100%;
      left: -1.3vw;
      position: relative;
      margin: 0;
    }


  
  }
  @media screen and (min-width: 1024px) {
    footer  .social-nav {  
      left: 3rem;
    }

  .footer-derecha .social-nav .nav-item{
    width: 3.2rem;
    padding: 0 0.6rem 0 0.6rem ;
  }

  .footer-derecha .social-nav .nav-item.youtube {
    width: 4.0rem;
    padding: 0 0.5rem 0 0.5rem ;
  }

  }  

</style>